module.exports = "/dist/4d08daebc07fbef23449c61e4ba59fed.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-300italic.woff
// module id = 150
// module chunks = 0